import { ClickLinkTypeEnum } from 'modules/mailing/email-statistics/enums/click-link-type-enum'
import { TLocoType } from 'shared/hooks/use-loco-translation'

export const getClickedLinkCustomCaption = (
  t: TLocoType,
  type?: ClickLinkTypeEnum,
  displayLinkName?: string,
) => {
  return (
    <div className={'flex gap-1 overflow-hidden pr-0.5'}>
      <span className="truncate">{displayLinkName}</span>
      {type === ClickLinkTypeEnum.AttachedFile && (
        <i className="text-text-tertiary">
          {t('dashboard.email_statistics.table_links.link_type.attachment_title')}
        </i>
      )}
    </div>
  )
}

export const getClickedLinkCaption = (
  t: TLocoType,
  type?: ClickLinkTypeEnum,
  displayLinkName?: string,
): string => {
  let caption = displayLinkName ?? ''
  if (type === ClickLinkTypeEnum.AttachedFile) {
    caption += ` ${t('dashboard.email_statistics.table_links.link_type.attachment_title')}`
  }
  return caption
}
